module.exports = __webpack_public_path__ + "static/turbo-f48391200ad47648cf51280fcb373e61.svg";